module.exports = __webpack_public_path__ + "img/b207afaa-654d-4b7e-b520-1c542075db5c.89175577.jpg";